import { render, staticRenderFns } from "./perfil-crm-card.vue?vue&type=template&id=7002c584&scoped=true"
import script from "./perfil-crm-card.vue?vue&type=script&lang=js"
export * from "./perfil-crm-card.vue?vue&type=script&lang=js"
import style0 from "./perfil-crm-card.vue?vue&type=style&index=0&id=7002c584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7002c584",
  null
  
)

export default component.exports